require('legacy/hasonefield.js');
require('boot');



// WEBPACK FOOTER //
// ./client/src/bundles/bundle.js